"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var GoldIcon = function (_a) {
    var active = _a.active, other = __rest(_a, ["active"]);
    var fill = active ? '#FFDA2D' : '#BDBDBD';
    var fillInner = active ? '#FDBF00' : '#EEEEEE';
    return (react_1.default.createElement("svg", __assign({ style: { width: 20, height: 20 } }, other, { viewBox: "0 0 512 512" }),
        react_1.default.createElement("g", null,
            react_1.default.createElement("path", { d: "M256 0C115.3 0 0 115.3 0 256C0 396.7 115.3 512 256 512C396.7 512 512 396.7 512 256C512 115.3 396.7 0 256 0Z", fill: fill }),
            react_1.default.createElement("path", { d: "M256 60C148.599 60 60 148.599 60 256C60 363.399 148.599 452 256 452C363.401 452 452 363.399 452 256C452 148.599 363.401 60 256 60Z", fill: fillInner }),
            react_1.default.createElement("path", { d: "M316 211C311.201 211 305.2 211.899 298.9 213.1C300.099 206.799 301 200.799 301 196C301 171.099 280.901 151 256 151C231.099 151 211 171.099 211 196C211 200.799 211.901 206.8 213.1 213.1C206.799 211.899 200.799 211 196 211C171.099 211 151 231.099 151 256C151 280.899 171.099 301 196 301C200.799 301 206.8 300.099 213.1 298.9C211.901 305.201 211 311.199 211 316C211 340.899 231.099 361 256 361C280.901 361 301 340.899 301 316C301 311.199 300.099 305.2 298.9 298.9C305.201 300.099 311.201 301 316 301C340.901 301 361 280.899 361 256C361 231.099 340.901 211 316 211Z", fill: fill }))));
};
exports.default = GoldIcon;
//# sourceMappingURL=GoldIcon.js.map